export default __webpack_public_path__ + "static/media/Projects-folder.5f90c9a1.svg";